import React from "react";

export default function OwnerSelect({ teammates, value, legacy, onChange, testId }) {
  return (
    <div>
      <select value={value || ""} onChange={(e) => onChange(e.target.value || null)} data-testid={testId}
        className="w-full px-3 py-2 rounded-lg border focus:outline-none focus:border-blue-500 text-sm">
        <option value="">Owner: unassigned</option>
        {teammates.map((t) => <option key={t.id} value={t.id}>{`Owner: ${t.name}`}</option>)}
      </select>
      {!value && legacy && <div className="text-[11px] text-slate-500 mt-1" data-testid={`${testId}-legacy`}>Previously: {legacy}</div>}
    </div>
  );
}
